module.exports = __webpack_public_path__ + "static/profile-ed8e0a08cd6ec9e069f3a13c9b167d20.jpg";